import { render, staticRenderFns } from "./ModalEditYieldGroupSize.vue?vue&type=template&id=122dc0ae"
import script from "./ModalEditYieldGroupSize.vue?vue&type=script&lang=js"
export * from "./ModalEditYieldGroupSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports